import React, { useEffect, useState, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import apiUrls from "../../constants/apiUrls";
import { toast } from "react-toastify";
import { customFormDataPost } from "../../helper/api-helper/apiHerlpers";
import { confirmDialog } from "primereact/confirmdialog";
import apis from "../../services/apis";
import apiCommonParams from "../../constants/apiCommonParams";
import "./EditProject.css";
import { useSmarkState } from "../../Context/KeycloakContext";
import AppContext from "../../Context/AppContext";

const EditProject = (props) => {
  const { applicationId, siteId } = useContext(AppContext);
  const userDetails = useSmarkState();
  const storedToken = localStorage.getItem("keycloakToken");

  const [showList, setShowList] = useState(props.val);
  const [editProject, setEditProject] = useState(false);
  const [projects, setProjects] = useState([]);
  const [project, setProject] = useState(null);

  const [projectName, setProjectName] = useState("");
  const [error, setError] = useState(false);
  const [exist, setExist] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getProjects();
  }, []);

  const getProjects = async () => {
    const data = await apis.getProjectsAllData(applicationId, siteId, storedToken);
    setProjects(data || []);
  };

  const onHideEditProject = () => {
    if (!isLoading) {
      props.onHideEditProjectEvent(false);
      setShowList(false);
    }
  };

  const onHideProject = () => {
    if (!isLoading) {
      setEditProject(false);
      setShowList(false);
      props.onHideEditProjectEvent(false);
    }
  };

  const editIconClickHandler = (item) => {
    setEditProject(true);
    setShowList(false);
    setProject(item);
    setProjectName(item.projectName);
    setExist(false);
    setError(false);
  };

  const projectDeleteConfirm = (item) => {
    confirmDialog({
      message: "Do you want to delete this record?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: () => deleteProject(item.projectId),
    });
  };

  const deleteProject = (projectId) => {
    setIsLoading(true);

    const body = new FormData();
    body.append("swcmTicket", apiCommonParams.swcmTicket);
    body.append("applicationid", applicationId);
    body.append("siteid", siteId);
    body.append("projectid", projectId);
    body.append("userid", userDetails.userId);

    customFormDataPost(apiUrls.deleteProject, body, storedToken)
      .then((response) => {
        props.loadMasterProjectDdl(storedToken);
        getProjects();
        toast.success(response.response);
      })
      .catch(() => {
        toast.error("Error");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const projectNameChangeHandler = (event) => {
    setProjectName(event.target.value);
    setError(false);
    setExist(false);
  };

  const submitButtonHandler = (event) => {
    event.preventDefault();

    if (!projectName.trim()) {
      setError(true);
      return;
    }

    setIsLoading(true);

    // Check duplicate
    const checkDuplicate = new FormData();
    checkDuplicate.append("applicationid", applicationId);
    checkDuplicate.append("siteid", siteId);
    checkDuplicate.append("project", projectName);
    checkDuplicate.append("swcmTicket", apiCommonParams.swcmTicket);

    customFormDataPost(apiUrls.editProject, checkDuplicate, storedToken)
      .then((res) => {
        if (res.response !== "success") {
          setExist(true);
          setIsLoading(false);
          return;
        }

        const body = new FormData();
        const data = {
          projectId: project.projectId,
          projectName: projectName,
          applicationId: applicationId,
          siteId: siteId,
          userCreated: project.userCreated,
          userModified: apiCommonParams.userModified,
          createdTime: project.createdTime,
          updatedTime: apiCommonParams.updatedTime,
        };

        body.append("project", JSON.stringify(data));
        body.append("swcmTicket", apiCommonParams.swcmTicket);
        body.append("userid", userDetails.userId);

        return customFormDataPost(apiUrls.saveProject, body, storedToken);
      })
      .then((response) => {
        if (response) {
          props.loadMasterProjectDdl(storedToken);
          getProjects();
          cancelButtonHandler();
          toast.success("Project name updated");
        }
      })
      .catch(() => {
        toast.error("Error");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const cancelButtonHandler = () => {
    if (!isLoading) {
      setEditProject(false);
      setShowList(true);
    }
  };

  const items = projects.map((x, index) => (
    <tr key={index}>
      <td>{x.projectName}</td>
      <td style={{ textAlign: "right" }}>
        <span onClick={() => editIconClickHandler(x)}>
          <i className="fas fa-pencil-alt"></i>
        </span>
        &nbsp;&nbsp;
        <span onClick={() => projectDeleteConfirm(x)}>
          <i className="fas fa-trash-alt"></i>
        </span>
      </td>
    </tr>
  ));

  return (
    <>
      {/* Project List Modal */}
      <Modal show={showList} onHide={onHideEditProject} backdrop="static">
        <Modal.Header closeButton={!isLoading}>
          <Modal.Title>All Projects</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-scroll">
          <table className="table">
            <thead className="thead-dark">
              <tr>
                <th>Project name</th>
                <th style={{ textAlign: "right" }}>Actions</th>
              </tr>
            </thead>
            <tbody>{items}</tbody>
          </table>
        </Modal.Body>
      </Modal>

      {/* Edit Project Modal */}
      <Modal show={editProject} onHide={onHideProject} backdrop="static">
        <Modal.Header closeButton={!isLoading}>
          <Modal.Title>Edit Project</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form>
            <div className="form-group">
              <label>Project name</label>
              <input
                type="text"
                value={projectName}
                onChange={projectNameChangeHandler}
                className="form-control required-field"
                placeholder="Project name"
                disabled={isLoading}
              />
              {error && (
                <span className="text-danger">Project name is required</span>
              )}
              {exist && (
                <span className="text-danger">Project name already exists</span>
              )}
            </div>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={cancelButtonHandler} disabled={isLoading}>
            Cancel
          </Button>
          <Button variant="primary" onClick={submitButtonHandler} disabled={isLoading}>
            {isLoading ? "Saving..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditProject;
